import React from 'react';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '20px',
  borderRadius = '8px',
  className = '',
}) => {
  return (
    <div
      className={`skeleton ${className}`}
      style={{
        width,
        height,
        borderRadius,
        background: 'linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 2s infinite ease-in-out',
      }}
    />
  );
};

export const SkeletonCard: React.FC = () => {
  return (
    <div
      style={{
        background: 'white',
        borderRadius: '16px',
        padding: '20px',
        border: '1px solid #e2e8f0',
        marginBottom: '12px',
      }}
    >
      <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
        <Skeleton width="60px" height="60px" borderRadius="12px" />
        <div style={{ flex: 1 }}>
          <Skeleton width="40%" height="16px" />
          <div style={{ height: '8px' }} />
          <Skeleton width="60%" height="14px" />
        </div>
      </div>
      <Skeleton width="100%" height="12px" />
      <div style={{ height: '8px' }} />
      <Skeleton width="80%" height="12px" />
    </div>
  );
};

export const SkeletonList: React.FC<{ count?: number }> = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </>
  );
};

export const SkeletonStats: React.FC = () => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '12px',
        marginBottom: '24px',
      }}
    >
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          style={{
            background: 'white',
            borderRadius: '16px',
            padding: '20px',
            border: '1px solid #e2e8f0',
          }}
        >
          <Skeleton width="50%" height="14px" />
          <div style={{ height: '12px' }} />
          <Skeleton width="70%" height="24px" />
        </div>
      ))}
    </div>
  );
};
